module.exports = __webpack_public_path__ + "img/82.2TN.3835c51a.png";